import React from 'react';
import { Modal, Button } from 'antd';

import CodeBlock from './CodeBlock';
import { TEST_IDS } from './testIds';

/**
 * Shown once, immediately after a key is created. The secret is not stored in
 * a recoverable form, so this is the only chance to copy it.
 */
const NewKeyModal = ({ open, apiKey, onClose }) => (
  <Modal
    centered
    open={open}
    onCancel={onClose}
    footer={null}
    className="api-key-modal"
    title="Your new API key"
    maskClosable={false}
  >
    <div data-testid={TEST_IDS.NEW_KEY_MODAL}>
      <div className="alert alert-warning" role="alert">
        Copy this key now — it will not be shown again. If you lose it, revoke
        the key and create a new one.
      </div>

      <CodeBlock
        label={apiKey?.name || 'API key'}
        value={apiKey?.key || ''}
        testId={TEST_IDS.NEW_KEY_VALUE}
        copyTestId={TEST_IDS.COPY_BTN}
      />

      <p className="text-muted mt-3 mb-0 small">
        Send it as an <code>Authorization</code> header on every request:
        <br />
        <code>Authorization: Api-Key &lt;your key&gt;</code>
      </p>

      <div className="text-end mt-4">
        <Button type="primary" onClick={onClose}>
          I've copied it
        </Button>
      </div>
    </div>
  </Modal>
);

export default NewKeyModal;
